export default class Formatter {
	constructor({
		id,
		name,
		definition,
		driver
	}) {
		this._id = id;
		this._name = name;
		this._definition = definition;
		this._driver = driver;
	}

	getId = () => this._id;

	getKey = () => String(this._id);

	getName = () => this._name;

	getDefinition = () => this._definition;

	getDriver = () => this._driver;

}
